<!--右下角功能块-->
<template>
<div>
  <div class="rightDownBox" @mouseenter="mouse(true)" @mouseleave="mouse(false)" v-if="type==1">
      <div class="position">
            <img src="../assets/111.jpeg" alt="">
            <div class="fontBlock" v-show="fontShow">{{title?title:'加入班群'}}</div>
            <div class="qrcode" v-show="qrcodeShow"></div>
      </div>
  </div>
  <div class="rightDownBox2" v-if="type==2">
      <div class="position2">
            <img src="../assets/img/addMe.png" alt="" @click="show()" v-if="logoShow">
            <div class="infoBox">
                <p @click="show()">{{title?title:'加入班群'}}</p>
                <transition name="draw" >
                <div class="qrcode" v-if="qrcodeShow">
                    <!-- <img src="../assets/111.jpeg" alt=""> -->
                    <div v-html="content"></div>
                    <div class="block">
                        <img @click="show(0)" src="../assets/img/shouqi.png" alt="">
                    </div>
                    <p class="shouqi" @click="show(0)">收起</p>
                </div>
                </transition>
            </div>
      </div>
  </div>
  <div class="rightDownBox2" v-if="type==3">
      <div class="position2">
            <img src="../assets/img/addMe.png" alt="" @click="show()" v-if="logoShow">
            <div class="infoBox">
                <p @click="show(1)">{{title?title:'加入班群'}}</p>
            </div>
            <img src="../assets/img/activity_off.png" class="close" @click="close()" alt="">
      </div>
      
  </div>

  <div class="rightDownBox3" v-if="type==13">
      <div class="position3">
            <img src="../assets/img/kjcAddMe.png" alt="" @click="show()">
            <div class="infoBox" @click="show(1)">{{title?title:'加入班群'}}</div>
      </div>
  </div>

  <div class="zhezhao" v-if="qrcodeShow" @click="show(0)"></div>
  <div class="windowImgBox" v-if="qrcodeShow">
      <img :src="content" alt="">
  </div>
</div>
</template>

<script>
export default {
    props: {
        type:Number,//1鼠标停留加入我们，2鼠标点击展开加入我们二维码，3鼠标点击弹框二维码,13kjc点击弹框二维码
        title:String,//默认文字：加入班群
        content:String,
    },
    data () {
        return {
            fontShow:false,//文字展示
            qrcodeShow:false,//二维码展示
            logoShow:false,//其他展示
        }
    },
    methods: {
        mouse(show){
            this.fontShow=show
            if(show){
                setTimeout(() => {
                    this.qrcodeShow=true
                }, 500);
            }else{
                this.qrcodeShow=false
            }
        },
        show(num){
            if(num==0){
                this.qrcodeShow=false
            }else if(num==1){//展示
                this.qrcodeShow=true
            }else{
                this.qrcodeShow=!this.qrcodeShow
            }
            
        },
        close(){
            this.$emit('close',true)
        },
    },
    mounted () {
        setInterval(()=>{
            this.logoShow=true
        },1000)
    }
}
</script>

<style scope lang="scss">
.draw-enter-active, .draw-leave-active {
    height: 156px;
    transition: all .8s ease;
}
.draw-enter, .draw-leave-to {
    height: 0;
}

.rightDownBox{
    position: fixed;
    right: 20px;
    bottom: 150px;
    z-index: 999;
    cursor: pointer;
    .position{
        position: relative;
        img{
            width: 50px;
            height: 50px;
        }
        .fontBlock{
            height: 30px;
            line-height: 30px;
            color: white;
            width: 100px;
            text-align: center;
            position: absolute;
            background: blue;
            top: 10px;
            right: 40px;
            border-bottom-left-radius: 20px;
            border-top-left-radius: 20px;
            //名字 整体速度 曲线速度 延迟 次数 反向
            animation: show .5s linear 0s 1 alternate;
            @keyframes show {
                0%{width: 0px;}
                100%{width: 100px;}
            }
        }
        .qrcode{
            width: 80px;
            height: 80px;
            background: red;
            position: absolute;
            right: 50px;
            top: 40px;
        }
    } 
}
.rightDownBox2{
    position: fixed;
    right: 20px;
    top: 275px;
    z-index: 999;
    cursor: pointer;
    .close{
        position: absolute !important;
        width: 25px !important;
        height: 25px !important;
        left: 45px !important;
        bottom: -150px !important;
        animation:initial !important;
    }
    .position2{
        position: relative;
        text-align: center;
        width: 120px;
        >img{
            width: 57px;
            // position: relative;
            z-index: 3;
            // animation: show 1.5s ease 0s 1 alternate;
            animation: show 2s cubic-bezier(0.18, 0.89, 0.32, 1.28) 0s 1 alternate;
            position: absolute;
            left: 36px;
            @keyframes show {
                0%{width: 10px;top: 80px;}
                80%{width: 50px;top: -10px;}
                100%{width: 57px;top: 0px;}
            }
        }
        .infoBox{
            width:114px;
            // height: 36px;
            border-radius:3px 3px 4px 4px;
            border:2px solid rgba(51,51,51,1);
            position: absolute;
            top: 75px;
            z-index: 2;
            font-size:14px;
            font-weight:bold;
            color:rgba(51,51,51,1);
            background:rgba(255,255,255,1);
            overflow: hidden;
            >p{
                background:rgba(250,220,30,1);
                height:36px;
                line-height:36px;
            }
            .qrcode{
                text-align: center;
                background:rgba(255,255,255,1);
                cursor: auto;
                font-size: 0;
                overflow: hidden;
                img{
                    // width: 94px;
                    // height: 94px;
                    width: 100%;
                    margin: 0 auto;
                    // margin: 17px auto;
                }
                .block{
                    font-size: 0;
                    line-height: 0;
                    img{
                        width: 20px;
                        height: 20px;
                        margin: 0;
                        cursor: pointer;
                    }
                }
                .shouqi{
                    font-size:12px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    cursor: pointer;
                    margin-bottom: 6px;
                }
            }
        }
    }
}
// kjc
.rightDownBox3{
    position: fixed;
    right: 20px;
    top: 275px;
    z-index: 999;
    cursor: pointer;
    .position3{
        position: relative;
        text-align: center;
        width: 120px;
        >img{
            width: 120px;
            z-index: 3;
            position: relative;
            right: 0;
        }
        .infoBox{
            width: 120px;
            position: absolute;
            z-index: 4;
            // left: calc(50% - 60px);
            left: 0;
            text-align: center;
            font-size:14px;
            font-weight:bold;
            color:rgba(51,51,51,1);
            bottom: 15px;
        }
    }
}




.zhezhao{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background:rgba(0,0,0,1);
    opacity:0.69;
    z-index: 1005;
}
.windowImgBox{
    position: fixed;
    width: 500px;
    height: auto;
    left: calc(50% - 250px);
    top: calc(50% - 320px);
    z-index: 1006;
    img{
        width: 100%;
    }
}

</style>